import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom";
import { Layout } from "../components/Layout";
import { Home } from "../pages/home";
import { Occurrences } from "../pages/occurrences";
import { Triage } from "../pages/triage";
import { Mapa } from "../pages/map";
import { Setores } from "../pages/sectors";
import { Users } from "../pages/users";
import { Notificacoes } from "../pages/notifications";
import { Relatorios } from "../pages/reports";
import { Configuracoes } from "../pages/configuration";
import { OrdensServico } from "@/pages/service-ordens";
import { OccurrenceEdit } from "@/pages/occurrences/edit";
import { Screening } from "@/pages/occurrences/screening";
import { CreateSector } from "@/pages/sectors/create";
import { OccurrenceDetails } from "@/pages/occurrences/view";
import { ViewSector } from "@/pages/sectors/view";
import { EditSector } from "@/pages/sectors/edit";
import { CreateServiceOrder } from "@/pages/service-ordens/create";
import { Teams } from "@/pages/teams";
import { CreateTeam } from "@/pages/teams/create";
import { EditTeam } from "@/pages/teams/edit";
import { ViewTeam } from "@/pages/teams/view";
import { EditServiceOrder } from "@/pages/service-ordens/edit";
import { ViewServiceOrder } from "@/pages/service-ordens/view";
import { CreateNotification } from "@/pages/notifications/create";
import { NotificationView } from "@/pages/notifications/view";
import { ViewUser } from "@/pages/users/view";
import { EditUser } from "@/pages/users/edit";
import { CreateUser } from "@/pages/users/create";
import { Banners } from "@/pages/banners";
import { CreateBanner } from "@/pages/banners/create";
import { EditBanner } from "@/pages/banners/edit";
import { ViewBanner } from "@/pages/banners/view";
import { WorkOrderValidation } from "@/pages/work-order-validation";
import { Login } from "@/pages/login";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { syncSentryUser, clearSentryUser } from "@/lib/sentryUser";

// Função para verificar se o token JWT está válido
const isTokenValid = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expiry = payload.exp * 1000; // Converter para milissegundos
    return Date.now() < expiry;
  } catch {
    return false;
  }
};

// Wrapper para rotas com Layout e proteção
const ProtectedLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("duas-vidas-token");

    if (!token) {
      navigate("/", { replace: true });
      return;
    }

    if (!isTokenValid(token)) {
      localStorage.removeItem("duas-vidas-token");
      localStorage.removeItem("duas-vidas-user");
      clearSentryUser();
      navigate("/", { replace: true });
      return;
    }

    // Restaura o contexto de usuario no Sentry ao recarregar a pagina com
    // uma sessao ja existente (o login so roda uma vez, mas o boot acontece
    // a cada refresh).
    syncSentryUser();
  }, [navigate]);

  const token = localStorage.getItem("duas-vidas-token");

  if (!token || !isTokenValid(token)) {
    return null;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota de login sem Layout */}
        <Route path="/" element={<Login />} />

        {/* Rotas com Layout (SideMenu + AppBar) */}
        <Route element={<ProtectedLayout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/triage" element={<Triage />} />
          <Route path="/work-order-validation" element={<WorkOrderValidation />} />
          <Route path="/occurrences" element={<Occurrences />} />
          <Route
            path="/occurrences/:protocol"
            element={<OccurrenceDetails />}
          />
          <Route
            path="/occurrences/:protocol/screening"
            element={<Screening />}
          />
          <Route
            path="/occurrences/:protocol/edit"
            element={<OccurrenceEdit />}
          />
          <Route path="/map" element={<Mapa />} />
          <Route path="/sectors" element={<Setores />} />
          <Route path="/sectors/view/:id" element={<ViewSector />} />
          <Route path="/sectors/edit/:id" element={<EditSector />} />
          <Route path="/sectors/create" element={<CreateSector />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/view/:id" element={<ViewUser />} />
          <Route path="/users/edit/:id" element={<EditUser />} />
          <Route path="/users/create" element={<CreateUser />} />
          <Route path="/usuarios" element={<Users />} />
          <Route path="/notificacoes" element={<Notificacoes />} />
          <Route path="/notifications" element={<Notificacoes />} />
          <Route
            path="/notifications/create"
            element={<CreateNotification />}
          />
          <Route
            path="/notifications/view/:id"
            element={<NotificationView />}
          />
          <Route path="/relatorios" element={<Relatorios />} />
          <Route path="/configuracoes" element={<Configuracoes />} />
          <Route path="/service-orders" element={<OrdensServico />} />
          <Route
            path="/service-orders/view/:id"
            element={<ViewServiceOrder />}
          />
          <Route
            path="/service-orders/edit/:id"
            element={<EditServiceOrder />}
          />
          <Route
            path="/service-orders/create"
            element={<CreateServiceOrder />}
          />
          <Route path="/teams" element={<Teams />} />
          <Route path="/teams/create" element={<CreateTeam />} />
          <Route path="/teams/edit/:id" element={<EditTeam />} />
          <Route path="/teams/view/:id" element={<ViewTeam />} />
          <Route path="/banners" element={<Banners />} />
          <Route path="/banners/create" element={<CreateBanner />} />
          <Route path="/banners/edit/:id" element={<EditBanner />} />
          <Route path="/banners/view/:id" element={<ViewBanner />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
